import i18n from 'modules/core/lib/i18n'

const toNumber = (amount: number | string): number => {
  const parsedAmount = typeof amount === 'number' ? amount : Number(amount)

  return Number.isFinite(parsedAmount) ? parsedAmount : 0
}

export const formatCounterAmount = (
  amount: number | string,
  isHourlyFixedBalance: boolean
): string => {
  const numericAmount = toNumber(amount)
  const normalizedAmount = isHourlyFixedBalance && Object.is(numericAmount, -0) ? 0 : numericAmount

  return i18n.formatNumber(normalizedAmount)
}

export const isHourlyFixedBalanceAllowance = (allowance: {
  isHourly: boolean
  isTimeWorked: boolean
  isOvertime: boolean
}): boolean => {
  return allowance.isHourly && !allowance.isTimeWorked && !allowance.isOvertime
}
